import SimpleFluidContainer from '@/components/FluidContainer/SimpleFluidContainer'
import CloudinaryImage from '@/components/CloudinaryImage'
import ArcadeShadowBadge from '@/components/Badge/ArcadeShadowBadge'
import { PRIZEWALL_CLOUDINARY_PATH } from '../../constants'
import ArcadeShelfWrapper from '../ArcadeShelfWrapper/ArcadeShelfWrapper'
import { classNames } from '@/util/tailwindHelpers'
import { MergedSeason } from '../../types'
import { ReactNode } from 'react'

type Props = {
  title: string
  description: string
  season: MergedSeason
  buttonSlot?: ReactNode
  className?: string
  titleClassName?: string
  subTitleClassName?: string
}

const ArcadePrizeWallHero = ({
  title,
  description,
  season,
  buttonSlot,
  className,
  titleClassName,
  subTitleClassName
}: Props) => {
  const mediaPath = `pages/arcade/seasons/${season.id}/`

  const { heroGlam } = season

  return (
    <ArcadeShelfWrapper bgClassName="!top-8 md:!top-[8em]">
      <SimpleFluidContainer
        targetWidth={1004}
        className={classNames(
          'mx-auto container pt-8 md:pt-[8em] pb-[35px] relative max-w-[1004px]',
          className
        )}
      >
        <div className="flex flex-col gap-8 md:gap-[13em] justify-center">
          <div className="flex flex-col gap-[2em] items-center">
            <CloudinaryImage
              imageId="star"
              path={PRIZEWALL_CLOUDINARY_PATH}
              layout="intrinsic"
              width={99}
              height={48}
            />
            <h1
              className={classNames(
                'h1 md:text-[7em] text-center',
                titleClassName
              )}
            >
              {title}
            </h1>
            <div className="body-lg text-center">{description}</div>
          </div>
          <div className="flex flex-col min-w-0 md:flex-row gap-[11.25em] flex-1 aspect-[940/460] items-center">
            <div
              className={`max-md:max-w-[290px] md:w-full order-2 md:order-1 mx-auto aspect-[${heroGlam.width}/${heroGlam.height}]`}
            >
              <CloudinaryImage
                imageId={heroGlam.asset}
                path={mediaPath}
                layout="intrinsic"
                width={heroGlam.width}
                height={heroGlam.height}
              />
            </div>
            <div className="flex flex-col gap-1 justify-center order-1 md:order-2 text-center md:text-left">
              <ArcadeShadowBadge
                label1="Limited To"
                label2="333pcs"
                className="mb-1 self-center md:self-start"
              />
              <h3 className={classNames('h3 md:text-[4em]', subTitleClassName)}>
                {heroGlam.title}
              </h3>
              <p className="body-md text-gray-300">{heroGlam.description}</p>
              {buttonSlot}
            </div>
          </div>
        </div>
      </SimpleFluidContainer>
    </ArcadeShelfWrapper>
  )
}

export default ArcadePrizeWallHero
